export const fileUploading = {
  attach_file: "Attach file",
  uploading_desc:
    "Allowed to upload {{fileCount}} files, total size {{fileSize}}. Large files must be sent to the email: <anchor>{{email}}</anchor>",
  file_counter: "Allowed to upload {{fileCount}} files",
  choose_or_drop: "Select or drop a file",
};
